import { FC } from "react";
import { Container, Grid } from "@mui/material";
import BottomSpacedPageHeader from "components/common/ui/BottomSpacedPageHeader";
import IngredientStockListTable from "components/inventory/ui/stockLevelList/IngredientStockListTable";

interface IngredientStockListPageProps {}

const IngredientStockListPage: FC<IngredientStockListPageProps> = () => {
  return (
    <Container>
      <BottomSpacedPageHeader>Food Inventory</BottomSpacedPageHeader>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <IngredientStockListTable />
        </Grid>
      </Grid>
    </Container>
  );
};

export default IngredientStockListPage;
